import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnDetectionBox } from './detection-box';
import { SnDetectionMetadata } from './detection-metadata';
import { SnDetectionResolution } from './detection-resolution';

export class SnDetection extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public label: string;

  @Expose()
  public detectionId: string;

  @Expose()
  public cameraId: string;

  @Expose()
  public timestamp: number; // in seconds

  @Expose()
  public confidence: number;

  @Expose()
  public imageUrl: string;

  @Expose()
  public box: SnDetectionBox;

  @Expose()
  public boxOriginal: SnDetectionBox;

  @Expose()
  public metadata: SnDetectionMetadata;

  @Expose()
  public resolution: SnDetectionResolution;

  @Expose()
  @Default(0)
  public relevance: number = 0;
}
